import {BoosterPage} from "./booster-page";

export class BoosterPageMapper {
  public static map(data: any) {
    const boosterPage: BoosterPage = new BoosterPage();
    boosterPage.date = data.date;
    boosterPage.isCustom = data.is_custom;
    boosterPage.mode = data.mode;
    boosterPage.id = data.page_id;
    boosterPage.status = data.status;
    boosterPage.title = data.title;
    boosterPage.url = data.url;
    boosterPage.pagesCount = data.pages_count || 10;

    return boosterPage;
  }
}
